import { API_URL } from "../../constants/axios";
import { fetchApi } from "../fetch";

export const getSpots = async (page , size) => {
  const searchParam = new URLSearchParams({
    page,
    size,
  });
  const res = await fetchApi.get(API_URL.GET_SPOTS + "?" + searchParam.toString())
  return res.data;
};

// 진입점 목록 화면은 검색·페이지 이동을 클라이언트에서 즉시 처리하기 위해 전체를 한 번에 받는다.
// 서버 `/spot` 은 페이징만 지원하고 검색 파라미터가 없어서, 페이지 단위로 필터링하면
// "현재 10건 안에서만 검색되는" 잘못된 동작이 된다.
const SPOT_FETCH_CHUNK = 500;

export const getSpotsAllPages = async () => {
  const first = await getSpots(0, SPOT_FETCH_CHUNK);
  const qrSpots = [...(first?.data?.qrSpots ?? [])];
  const count = Number(first?.data?.count ?? qrSpots.length);

  // 한 청크로 다 안 담기면 이어서 받는다(잘려서 "없는 진입점"이 되는 것을 막는다).
  // 빈 페이지가 오면 즉시 중단 → 서버가 count 를 과대 보고해도 무한루프가 되지 않는다.
  let page = 1;
  while (qrSpots.length < count) {
    const rows = (await getSpots(page, SPOT_FETCH_CHUNK))?.data?.qrSpots ?? [];
    if (rows.length === 0) {
      break;
    }
    qrSpots.push(...rows);
    page += 1;
  }

  return { ...first, data: { qrSpots, count } };
};

export const getSpot = async (spotId) => {
  const res = await fetchApi.get(API_URL.GET_SPOT.replace("{spotId}", spotId));
  return res.data;
};

export const getAllSpots = async () => {
  const res = await fetchApi.get(API_URL.GET_ALL_SPOTS);
  return res.data;
};

/**
 * 발송 모수(Layer 1) 진입점 picker 용 목록.
 * `getAllSpots()` 는 id·name 만 주므로 별도다 — 여기서는 type·address·memberCount 도 온다.
 * 정렬은 서버에서 회원 수 내림차순으로 온다.
 */
export const getPoolSpots = async () => {
  const res = await fetchApi.get(API_URL.GET_POOL_SPOTS);
  if (res.status === 200) {
    return res.data;
  }
  return { data: [] };
};

export const saveSpot = async (spotId, type, name, address, qrShape) => {
  const res = await fetchApi.post(
    API_URL.UPDATE_SPOT,
    {
      id: spotId,
      type: type,
      name: name,
      address: address,
      qrShape: qrShape
    }
  );
  if (res.status === 200) {
    return res.data;
  }
  return res.data;
};

export const listPasswordSpots = async () => {
  const res = await fetchApi.get(API_URL.GET_ALL_PASSWORD_SPOTS);
  return res.data;
};

export const updatePassword = async (entryPoints) => {
  const res = await fetchApi.post(API_URL.UPDATE_ENTRYPOINT_PASSWORD, {entryPoints});
  if (res.status === 200) {
    return res.data;
  }
  return res.data;
};


export const updateQRCode = async (id, qrShape) => {
  const res = await fetchApi.post(API_URL.UPDATE_QRCODE, {id, qrShape});
  if (res.status === 200) {
    return res.data;
  }
  return res.data;
};

// ===== 진입점 그룹(해시태그) — 2026-08-27 =====
// 태그는 대량의 진입점을 묶어서 다루기 위한 **관리 보조 수단**이다.
// 이벤트에는 여전히 진입점 id 목록이 저장되므로, 태그를 바꿔도 기존 이벤트는 바뀌지 않는다.

/** 채널의 태그 목록 + 각 태그의 진입점 수. */
export const getSpotTags = async () => {
  const res = await fetchApi.get(API_URL.SPOT_TAGS);
  return res.data;
};

/** `spotId -> 태그목록` 맵. 목록 화면이 행마다 칩을 그린다. */
export const getSpotTagsBySpot = async () => {
  const res = await fetchApi.get(API_URL.SPOT_TAGS_BY_SPOT);
  return res.data;
};

/** 태그에 속한 진입점 id 목록. "태그로 선택" 이 쓴다. */
export const getSpotIdsByTag = async (tagCode) => {
  const res = await fetchApi.get(`${API_URL.SPOT_TAG_SPOTS}?tagCode=${encodeURIComponent(tagCode)}`);
  return res.data;
};

/** 진입점들에 태그 붙이기(멱등). */
export const attachSpotTag = async (spotIds, tagCode) => {
  const res = await fetchApi.post(API_URL.SPOT_TAG_ATTACH, {spotIds, tagCode});
  return res.data;
};

/** 진입점들에서 태그 떼기(멱등). */
export const detachSpotTag = async (spotIds, tagCode) => {
  const res = await fetchApi.post(API_URL.SPOT_TAG_DETACH, {spotIds, tagCode});
  return res.data;
};

/** 태그 이름 변경(같은 이름이 있으면 병합). */
export const renameSpotTag = async (fromCode, toCode) => {
  const res = await fetchApi.post(API_URL.SPOT_TAG_RENAME, {fromCode, toCode});
  return res.data;
};

/** 태그 삭제 — 모든 진입점에서 뗀다. 진입점 자체와 기존 이벤트 연결은 그대로다. */
export const deleteSpotTag = async (tagCode) => {
  const res = await fetchApi.delete(`${API_URL.SPOT_TAGS}?tagCode=${encodeURIComponent(tagCode)}`);
  return res.data;
};
